import { createStyles, alpha, makeStyles, Theme } from '@material-ui/core/styles';

export const useStaffAccordionStyles = makeStyles((theme: Theme) => {
  const dark = theme.palette.type === 'dark';
  return createStyles({
    avatar: {
      width: 40,
      height: 40,
      borderRadius: '50%',
      objectFit: 'cover',
      flexShrink: 0,
    },
    badgeIcon: {
      marginLeft: 8,
      display: 'inline-flex',
      color: theme.palette.primary.main,
    },
    separator: {
      margin: '0 6px',
    },
    toolbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 16,
      marginBottom: theme.spacing(2),
    },
    loadMoreRow: {
      display: 'flex',
      justifyContent: 'center',
      padding: theme.spacing(2),
      borderTop: `1px solid ${alpha(theme.palette.text.secondary, dark ? 0.16 : 0.1)}`,
    },
    skeletonRow: {
      padding: '16px 20px',
    },
    // Legend links the name through to the admin's profile; the row still toggles
    // everywhere else, so the link needs its own hit area and no blue-link styling.
    profileLink: {
      color: 'inherit',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  });
});
